<template>
  <div>
    <div class="app-card-header primary-actions">
      <div class="heading-block">
        <h4 class="heading">{{ table.title }}</h4>
      </div>
      <div class="actions-block">
        <!--Seller Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            :value="filters.sellers.checked"
            :items="filters.sellers.items"
            :loading="sellers.isLoading"
            :search-input.sync="sellers.search"
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            single-line
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="seller_name"
            item-value="seller_id"
            label="Seller"
            placeholder="Seller"
            class="placeholder-hardcoded"
            solo
            flat
            multiple
            @change="checkSeller($event, 'seller_id')"
          >
            <template v-slot:selection="data">
            </template>
          </v-autocomplete>
        </div>
        <!--Category Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            :value="filters.categories.checked"
            :items="filters.categories.items"
            :loading="categories.isLoading"
            :search-input.sync="categories.search"
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="category_name"
            item-value="category_id"
            label="Category"
            placeholder="Category"
            class="placeholder-hardcoded"
            solo
            flat
            multiple
            @change="checkSeller($event, 'category_id')"
          >
            <template v-slot:selection="data">
            </template>
          </v-autocomplete>
        </div>
        <!--Reset Button-->
        <v-btn
          :disabled="!filters.sellers.checked.length && !filters.categories.checked.length"
          color="primary"
          flat
          small
          :ripple="false"
          @click="resetFilter()"
        >
          <v-icon>autorenew</v-icon>
        </v-btn>
        <div class="separator-line"></div>
        <!--Download Excel-->
        <v-tooltip top max-width="235px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''} +  i-tooltip`]">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                class="mx-0"
                color="primary"
                flat
                small
                :ripple="false"
                @click="downloadHandler()"
              >
                <v-icon>icon-icon</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Download Excel</span>
        </v-tooltip>
      </div>
    </div>
    <div class="card-body pa-0">
      <v-progress-circular
        v-if="table.loading && table.items.length <= 0"
        :indeterminate="true"
        :size="75"
        height="3"
        color="primary"
        class="progress-circular" />
      <v-progress-linear
        v-if="table.loading && table.items.length > 0"
        :indeterminate="true"
        height="3"
        color="primary"
        class="progress-card" />
      <v-data-table
        v-if="!table.noData"
        :items="!filters.sellers.checked.length && !filters.categories.checked.length ? table.items : table.filteredItems"
        :headers="table.headers"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :hide-actions="(table.loading && !table.items.length) || table.noData"
        :hide-headers="(table.loading && !table.items.length) || table.noData"
        no-data-text=""
        class="i-table">
        <template v-slot:items="props">
          <template>
            <tr>
              <td>{{ props.item.seller_name }}</td>
              <td>{{ props.item.category_name }}</td>
              <td>{{ props.item.coverage }}</td>
              <td class="negative-td">{{ props.item.my_min }}</td>
              <td class="positive-td">{{ props.item.my_max }}</td>
              <td>{{ props.item.seller_min }}</td>
              <td>{{ props.item.seller_max }}</td>
              <td>{{ props.item.seller_avg }}</td>
            </tr>
          </template>
        </template>
      </v-data-table>
      <i-no-data heading="Oops!" v-if="table.noData && (!table.loading && !table.items.length)" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'sellersDataDistribution',
  props: {
    table: {
      type: [Object, Array],
      default: null
    },
    filters: {
      type: [Object, Array],
      default: null
    },
    categories: {
      type: [Object, Array],
      default: null
    },
    sellers: {
      type: [Object, Array],
      default: null
    }
  },
  data: () => ({
    rowsPerPageItems: [10, 25, 50, 100],
    pagination: {
      rowsPerPage: 100
    }
  }),
  mounted () {
    this.requestSellersDataDistribution()
  },
  methods: {
    requestSellersDataDistribution () {
      this.$store.dispatch('analyticsSellersCategoryDistributionModule/getSellersDataDistribution', {
        sellers: [],
        categories: [],
        brands: []
      })
    },
    checkSeller (items, type) {
      this.$store.commit('analyticsSellersCategoryDistributionModule/ADD_filters', {item: items, type: type})
    },
    resetFilter () {
      this.$store.commit('analyticsSellersCategoryDistributionModule/ADD_filters', {item: [], type: 'all'})
    },
    downloadHandler () {
      this.$emit('downloadExcel')
    }
  },
  computed: {
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/sellersCategoryDistribution.vue